module.exports = __webpack_public_path__ + "static/media/PRF.b3d0b14e.svg";